<template>
  <pl-dialog @close="$emit('close')" :size="'md'" title="Secret identity" :disableOutsideClick="true">
    <div class="bg-gray-100 py-7">
      <div class="flex justify-center">
        <img
          class="w-14 h-14 rounded-full object-cover mb-2"
          :src="anonymous_identity.avatar_url"
        />
      </div>
      <h6 class="text-center text-gray-800">{{ anonymous_identity.name }}</h6>
    </div>
    <div class="text-sm font-light px-12 py-8 mb-10 leading-6 overflow-y-auto" v-html="anonymous_identity.description">

    </div>
    
    <!-- <div>
      <div class="mb-4 flex items-center">
        
        <div class="text-lg font-semibold"></div>
      </div>
      <div class="pl-subheading description-body">
        {{ anonymous_identity.description }}
      </div>
    </div> -->
  </pl-dialog>
</template>

<script>
  import Vue from 'vue';
  export default Vue.extend({
    props: {
      anonymous_identity: {
        type: Object,
        default() {
          return {
            name: 'Parlay Character',
            avatar_url: '',
            description: '',
          };
        },
      },
    },
  });
</script>
<style scoped lang="stylus">
  .description-body
    height: calc(60vh - 104px);
    overflow-y: scroll
</style>



// WEBPACK FOOTER //
// anonymousCharacterDescriptionModal.vue?4ba7018e